import { useEffect, useState } from 'react';

/**
 * Hook to determine if the user's device supports touch input.
 *
 * This hook uses the `pointer: coarse` media query to detect touch capability.
 * It listens for changes in the media query and updates the state accordingly.
 *
 * @returns {boolean} - A boolean value indicating whether the device supports touch input.
 *
 * @example
 * ```tsx
 * const hasTouch = useHasTouch();
 * console.log(hasTouch); // true if the device supports touch, false otherwise
 * ```
 */
export const useHasTouch = () => {
  const [hasTouch, setHasTouch] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(pointer: coarse)');

    const callback = () => setHasTouch(mediaQuery.matches);

    callback();

    mediaQuery.addEventListener?.('change', callback);

    return () => {
      mediaQuery.removeEventListener?.('change', callback);
    };
  }, []);

  return hasTouch;
};
